import { Plugins } from '@leverege/plugin';
import ItemModel from './ItemModel.js';
import ItemEditor from "./ItemEditor.js";
import ItemTypeModel from './ItemTypeModel.js';
import ItemTypeEditor from "./ItemTypeEditor.js";
import ItemListCard from "./ItemListCard.js";
import { createDetailExportModel } from '../DetailExportModelCreator.js';
export default {
  install: opts => {
    Plugins.add('Model', {
      type: ItemModel.TYPE,
      model: ItemModel
    });
    Plugins.add('ModelEditor', {
      type: ItemModel.TYPE,
      editor: ItemEditor
    });
    Plugins.add('ExportModelCreator', {
      type: ItemModel.TYPE,
      creator: createDetailExportModel
    });
    Plugins.add('Model', {
      type: ItemTypeModel.TYPE,
      model: ItemTypeModel
    });
    Plugins.add('ModelEditor', {
      type: ItemTypeModel.TYPE,
      editor: ItemTypeEditor
    });
    Plugins.add('ItemCard', {
      type: 'detail.DetailList',
      card: ItemListCard
    });
  }
};